<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.alarm_type_sbo") }}</label>
        <v-select
          :value="typeAlarmFilter"
          :options="typeAlarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Dispatch Alarm</label>
        <v-select
          :value="dispatchAlarmFilter"
          :options="[{label: 'True', value: true}, {label: 'False', value: false}]"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:dispatchAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.event_code") }}</label>
        <v-select
          :value="eventCodeFilter"
          :options="eventCodeOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:eventCodeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCard, BCardHeader, BCardBody, BRow, BCol, BButton} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    typeAlarmOptions: {
      type: Array,
    },
    typeAlarmFilter: {
      default: null,
    },
    eventCodeOptions: {
      type: Array,
    },
    eventCodeFilter: {
      default: null,
    },
    dispatchAlarmFilter: {
      default: null,
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
